import {
    GenericFormContainer,
    Grid,
    IAlertData,
    Leap4Breadcrumbs,
    setAlert,
    Spinner,
    Mode,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";
import { useHistory, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {IAlert} from "@leap4/entities-discrepancy-common";
import {initialAlertObj} from "../base/Alert";
import {ApiClient} from "../../../../../utils/apiClient";
import {urlService} from "../../../../routing/urlsService";
import {AlertContext} from "../base/AlertContex";
import {DetailsForm} from "../base/DetailsForm";
import {RootState} from "../../../../../store/store";
import {connect} from "react-redux";
import {EditAlertStore} from "./EditAlertStore";
import {AlertsBaseUrl} from "../../../../../config/generals";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../../shared/OneOrgOnly/OneOrgOnly";

const {AddTask: AddTaskIcon} = MuiIcons;

export interface IEditAlertProps {
    setAlert: (data: IAlertData) => void;
}


let editAlertStore: EditAlertStore

const _editAlert = (props: IEditAlertProps) => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const [alert, setAlert] = useState<IAlert>(initialAlertObj);
    const [dataPoints, setDataPoints] = useState([])
    const alertContextValue = useMemo(() => ({alert, dataPoints, setDataPoints, setAlert}), [alert, dataPoints]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)


    useEffect(() => {
        if (!params.id) {
            return;
        }
        editAlertStore = new EditAlertStore({
                setIsLoading,
                setIsLoadError,
                setItem: setAlert,
                axiosClient: ApiClient,
                alertFunc: props.setAlert,
                baseUrl: `${AlertsBaseUrl}`
            }
        )
        editAlertStore.refreshItem(params.id)
    }, [params.id])


    const onSubmit = async () => {
        if (!alert._id) {
            return;
        }
        await editAlertStore.updateById(alert._id.toString(), alert);
        history.push(urlService.alerts());
    };

    const onDelete = async () => {
        if (!alert || !alert._id) {
            return
        }
        await editAlertStore.deleteItem(alert._id.toString());
        history.push(urlService.alerts());
    };

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "Alerts Dashboard",
                link: urlService.alerts(),
                icon: <TocIcon/>
            },
                {
                    text: alert.name,
                    icon: <AddTaskIcon/>
                }]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} onDeleteFunction={onDelete}>
                <AlertContext.Provider value={alertContextValue}>
                    <DetailsForm mode={"edit"}/>
                </AlertContext.Provider>
            </GenericFormContainer>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({});

export const EditAlert = connect(mapStateToProps, {
    setAlert: setAlert
})(_editAlert);




